import list from './list'
import create from './create'
import previewModal from './previewModal'
import acceptModal from './acceptModal'
import rejectModal from './rejectModal'
import show from './show'
import update from './update'
import emailPropositionModal from './emailPropositionModal'
import createAgreementItemsModal from './createAgreementItemsModal'
import createAgreementAdditionalItemsModal from './createAgreementAdditionalItemsModal'
import generateInvoicesFromAgreementModal from './generateInvoicesFromAgreementModal'

export default {
  namespaced: true,
  modules: {
    list,
    create,
    previewModal,
    acceptModal,
    rejectModal,
    show,
    update,
    emailPropositionModal,
    createAgreementItemsModal,
    createAgreementAdditionalItemsModal,
    generateInvoicesFromAgreementModal
  }
}
